module.exports = __webpack_public_path__ + "img/logo.0c32f321.png";